import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoCipherService {
  passPhrase = environment.passPhrase;

  encryptSecret(secret: string): string {
    return CryptoJS.AES.encrypt(secret, this.passPhrase).toString();
  }

  decryptSecret(cipher: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(cipher, this.passPhrase);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (err) {
      return 'failed';
    }
  }
}
